import { omitPathParameters, replacePathParameters } from "../../utils.ts";
import type { AxiosInstance, AxiosRequestConfig } from "axios";
import type * as Paths from "./paths";

export const getDiscountOperations = (client: AxiosInstance) => {
  const getGiftItemVariants = (
    parameters: Paths.GetGiftVariants.PathParameters &
      Paths.GetGiftVariants.QueryParameters,
    data?: null | undefined,
    config?: AxiosRequestConfig,
  ) => {
    const url = "/discount/{id}/gift-item-variants";
    return client.get<Paths.GetGiftVariants.Responses.$200>(
      replacePathParameters(url, parameters),
      {
        params: omitPathParameters(parameters, url),
        data: data,
        ...config,
      },
    );
  };

  const getNewGiftItemVariants = (
    parameters: Paths.GetNewGiftVariants.QueryParameters,
    data?: null | undefined,
    config?: AxiosRequestConfig,
  ) => {
    const url = "/discount/gift-item-variants";
    return client.get<Paths.GetNewGiftVariants.Responses.$200>(
      replacePathParameters(url, parameters),
      {
        params: omitPathParameters(parameters, url),
        data: data,
        ...config,
      },
    );
  };

  return {
    getGiftItemVariants,
    getNewGiftItemVariants,
  };
};
